import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const customerService = { constants, slice, sagas };

export default customerService; 